import type { TraceEntry } from './trace-buffer'

let db: IDBDatabase | null = null
const DB_NAME = 'TraceDB'
const STORE_NAME = 'traces'
const DB_VERSION = 1

export function initDB(): Promise<void> {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION)

    request.onerror = () => reject(request.error)
    request.onsuccess = () => {
      db = request.result
      resolve()
    }

    request.onupgradeneeded = (event) => {
      const database = (event.target as IDBOpenDBRequest).result

      if (!database.objectStoreNames.contains(STORE_NAME)) {
        const store = database.createObjectStore(STORE_NAME, { keyPath: 'id' })
        store.createIndex('timestamp', 'timestamp', { unique: false })
      }
    }
  })
}

export async function persistTraces(traces: TraceEntry[], sync: boolean = false): Promise<void> {
  if (!db) {
    await initDB()
  }

  if (!db) {
    throw new Error('Проблема инициализации БД')
  }

  return new Promise((resolve, reject) => {
    const transaction = db!.transaction(STORE_NAME, 'readwrite')
    const store = transaction.objectStore(STORE_NAME)

    traces.forEach((trace) => {
      store.put(trace)
    })

    if (sync) {
      transaction.oncomplete = () => resolve()
      transaction.onerror = () => reject(transaction.error)
    } else {
      resolve()
    }
  })
}

export async function loadTraces(): Promise<TraceEntry[]> {
  if (!db) {
    await initDB()
  }

  if (!db) {
    return []
  }

  return new Promise((resolve, reject) => {
    const transaction = db!.transaction(STORE_NAME, 'readonly')
    const store = transaction.objectStore(STORE_NAME)
    const request = store.getAll()

    request.onsuccess = () => resolve(request.result as TraceEntry[])
    request.onerror = () => reject(request.error)
  })
}

export async function cleanupOldTraces(ttlMs: number = 24 * 60 * 60 * 1000): Promise<void> {
  return Promise.resolve()
}

export async function clearAllTraces(): Promise<void> {
  if (!db) {
    await initDB()
  }

  if (!db) {
    return
  }

  return new Promise((resolve, reject) => {
    const transaction = db!.transaction(STORE_NAME, 'readwrite')
    const store = transaction.objectStore(STORE_NAME)
    const request = store.clear()

    request.onsuccess = () => resolve()
    request.onerror = () => reject(request.error)
  })
}
